import { Controller } from '@hotwired/stimulus';
import { showToast } from '../lib/toast';

// Displays Rails flash messages as toasts on connect.
//
// Usage:
//   <div data-controller="flash"
//        data-flash-messages-value='[{"type":"success","message":"Done!"}]'></div>
export default class extends Controller {
  static values = {
    messages: { type: Array, default: [] },
  };

  connect() {
    this.messagesValue.forEach(({ type, message }) => showToast(type, message));
  }
}
